module.exports = __webpack_public_path__ + "static/media/ico_admin.1bc3f0bf.png";